export default __webpack_public_path__ + "static/media/header-back.5062e5e5.jpg";